/**
 * @file
 * Spinner buttons functionality.
 */

((Drupal, once) => {

  /**
   * Decrease number field.
   *
   * @param props
   */
  function decreaseNumberField(props) {
    const _$numberField = props._$dec.parentElement.nextElementSibling;
    let _currentValue = parseInt(_$numberField.value);

    if (_currentValue > 0) {
      _$numberField.value = _currentValue - 1;
    }
  }

  /**
   * Increase number field.
   *
   * @param props
   */
  function increasdeNumberField(props) {
    const _$numberField = props._$asc.parentElement.previousElementSibling;
    let _currentValue = parseInt(_$numberField.value);

    if (_currentValue === 0 || _currentValue > 0) {
      _$numberField.value = _currentValue + 1;
    }
  }

  /**
   * Initialize spinner buttons.
   *
   * @param props
   */
  function init(props) {
    props._$dec.addEventListener('click', () => {
      decreaseNumberField(props);
    });

    props._$asc.addEventListener('click', () => {
      increasdeNumberField(props);
    });
  }

  Drupal.behaviors.spinnerButtons = {
    attach(context) {
      const _$spinnerButtons = once('spinnerButtons', '[data-spinner-buttons] .js-form-type-number', context);

      if (_$spinnerButtons) {
        _$spinnerButtons.forEach(_$spinnerButton => {
          const _$dec = once('dec', '[data-spinner-button-dec]', _$spinnerButton).shift();
          const _$asc = once('asc', '[data-spinner-button-asc]', _$spinnerButton).shift();

          init({_$dec, _$asc});
        });
      }
    }
  };
})(Drupal, once);
